export const ApiError = {
  failedFetch: "Failed to fetch",
  syntax: "SyntaxError",
  technical: "error_tecnico"
}

export const FeedbackError = {
  failedFetch: {
    title: "Error de conexión",
    desc: "Lo sentimos, algo salió mal, por favor inténtalo de nuevo"
  },
  existingPolicy: {
    title: "Póliza existente",
    desc: "Ya existe una póliza con el VIN ingresado"
  },
  cannotBeInsured: {
    title: "¡Lo sentimos!",
    desc: "Por el momento no podemos asegurar tu vehículo."
  }
}
